import React from 'react'
import { useLanguage } from '~components'
import { BottomBar, BottomText, BottomBtn } from '../HomeHero/styles'
import {
  PolicyContainer,
  PageHeader,
  PageTitle,
  PageSubtitle,
  TopDivider,
  BottomDivider,
  ContentContainer,
  Section,
  SectionTitle,
  SectionText,
  HighlightText,
  NormalText,
  BulletList,
  BulletItem,
  BackgroundWatermark
} from './styles'

import logoIcon from '../../../../assets/images/newimage/logo.svg'

// Reusable structural component for privacy sections
const PolicySection = ({ title, highlightDesc, normalDesc, desc, items }) => (
  <Section>
    <SectionTitle>{title}</SectionTitle>
    {highlightDesc && (
      <SectionText>
        <HighlightText>{highlightDesc}</HighlightText>{' '}
        <NormalText>{normalDesc}</NormalText>
      </SectionText>
    )}
    {desc && (
      <SectionText>
        <NormalText>{desc}</NormalText>
      </SectionText>
    )}
    {items && (
      <BulletList>
        {items.map((item, i) => (
          <BulletItem key={i}>{item}</BulletItem>
        ))}
      </BulletList>
    )}
  </Section>
)

export const PrivacyPolicy = (props) => {
  const [, t] = useLanguage()

  return (
    <PolicyContainer>
      <PageHeader>
        <PageTitle>{t('PRIVACY_POLICY', 'PRIVACY POLICY')}</PageTitle>
        <PageSubtitle>{t('PRIVACY_POLICY_SUBTITLE', 'How we collect, use, and protect your information.')}</PageSubtitle>
      </PageHeader>

      <TopDivider />

      <ContentContainer>
        <BackgroundWatermark img={logoIcon} />

        <PolicySection
          title={`1. ${t('INFORMATION_WE_COLLECT', 'INFORMATION WE COLLECT')}`}
          highlightDesc={t('INFORMATION_WE_COLLECT_DESC_1', 'Sonamarthen dhartitories your tenners poole by')}
          normalDesc={t('ID_VERIFICARY_LOT', 'ID verificary lot ahalir')}
        />

        <PolicySection
          title={`2. ${t('INFE_DORMATION_WE_COLLECT', 'INFE DORMATION WE COLLECT')}`}
          desc={t('INFE_DORMATION_WE_COLLECT_DESC', 'Userrs muce sallon gall this muts andery to the service.')}
        />

        <PolicySection
          title={`3. ${t('HOW_INASION_USE_USE_DATA', 'HOW INASION USE USE DATA')}`}
          desc={t('HOW_INASION_USE_USE_DATA_DESC', 'independent atfiliates umdates dne Bottle Runner systen opectuch.')}
          items={[
            t('HOW_INASION_USE_USE_DATA_POINT_1', 'Als tromagod as hood to purs the words ih al faral opsuce and is pratter ofed atsinas codoutals opestaelly urthurs'),
            t('HOW_INASION_USE_USE_DATA_POINT_2', 'Row five FArt the the pronall this soule up taree tesoriss wisill ltseads how an prateting those whis gusd a inger liievdicat wall lecional lonent ther lonal system.')
          ]}
        />
      </ContentContainer>

      <BottomDivider />

      <BottomBar>
        <BottomText>{t('PLACE_AN_ORDER_FOR_DELIVERY', 'PLACE AN ORDER FOR DELIVERY')}</BottomText>
        <BottomBtn>{t('START_ORDER', 'START ORDER')}</BottomBtn>
      </BottomBar>
    </PolicyContainer>
  )
}
